import axios from "axios";
import { getApiUrl } from "@/constants";
import { getToken } from "@/dataprovider/http-client";
import { getRouteIdFromPathname } from "@/utils/route-utility";

export async function uploadRazaSafai(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const token = await getToken();
  const eventId = getRouteIdFromPathname() ?? "";
  const impersonatedTenantId = localStorage.getItem("impersonatedTenantId");

  const headers: Record<string, string> = {
    authorization: token,
    EventID: eventId,
  };
  if (impersonatedTenantId) {
    headers["x-impersonated-tenant-id"] = impersonatedTenantId;
  }

  const response = await axios.post<{ image?: string }>(
    `${getApiUrl("razaRequests")}/razaRequests/upload-safai`,
    formData,
    { headers }
  );

  const image = response.data?.image;
  if (!image) {
    throw new Error("Upload did not return an image URL");
  }
  return image;
}
